/*
 * Copyright (c) 2022-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { h } from 'preact';

import { useWidgetContext } from '../../contexts';
import {
  ChromeDtcContainerElement, UISchemaElementComponent,
} from '../../types';
import { getBaseUrl } from '../../util';
import HiddenIFrame from '../HiddenIFrame';

const ChromeDtcContainer: UISchemaElementComponent<{
  uischema: ChromeDtcContainerElement
}> = ({ uischema }) => {
  const {
    options: {
      href,
    },
  } = uischema;
  const { widgetProps } = useWidgetContext();
  const deviceChallengeUrl = new URL(href, getBaseUrl(widgetProps)).toString();

  return (
    <HiddenIFrame
      id="chrome-dtc-container"
      src={deviceChallengeUrl}
    />
  );
};

export default ChromeDtcContainer;
